import styled, { StyledComponent } from '@emotion/styled'
import { InputHTMLAttributes } from 'react'
import {
  BackgroundColorProps,
  color as styledColor,
  height,
  HeightProps,
  maxWidth,
  MaxWidthProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  width,
  WidthProps,
} from 'styled-system'

import { Theme } from '../Theme'
import { themeColor, themeFont } from '../Theme/utils'

type InputBorderProps = {
  border?: boolean | string
  highlight?: boolean
}
const inputBorder = (props: InputBorderProps & { theme: Theme }) => {
  if (!props.border) return ``

  const colorName = props.border === true ? 'primary' : props.border
  const colorFromTheme = themeColor(colorName, props.theme)

  return `
  box-shadow: ${
    props.highlight ? color : themeColor('lights.0', props.theme)
  } 0 1px 0;
    :focus {
        box-shadow: ${colorFromTheme} 0 1px 0;
    }
  `
}

export type InputProps = {
  readOnly?: boolean
} & InputBorderProps &
  TypographyProps &
  BackgroundColorProps &
  WidthProps &
  MaxWidthProps &
  SpaceProps

export const TextInput: StyledComponent<
  InputProps,
  Omit<InputHTMLAttributes<HTMLInputElement>, keyof InputProps>
> = styled.input<InputProps>`
  display: flex;
  outline: 0;
  font-family: ${themeFont};
  border: none;

  transition: box-shadow 0.2s ease;

  ${space}
  ${styledColor}
  ${width}
  ${maxWidth}
  ${inputBorder}
  ${typography}
`
TextInput.defaultProps = {
  type: 'text',
  border: true,
  fontSize: 18,
  fontWeight: 400,
  lineHeight: 1.4,
  py: '4px',
}

type TextAreaProps = {
  resize?: boolean
  readOnly?: boolean
} & InputProps &
  HeightProps

export const TextArea: StyledComponent<
  TextAreaProps,
  InputHTMLAttributes<HTMLTextAreaElement>
> = styled(TextInput.withComponent('textarea'))<TextAreaProps>`
  ${props => (!props.resize ? 'resize: none;' : 'resize: vertical;')}
  ${height}
`
TextArea.defaultProps = {
  border: true,
  fontSize: 18,
  fontWeight: 400,
  lineHeight: 1.4,
  resize: true,
}
